module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chevron_left-3020e7daade55043631887fd8a2bad3f.svg";